var _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7321 2L10.5 1.28868C10.1906 1.11004 9.80944 1.11004 9.50004 1.28868L2.70581 5.21132C2.39641 5.38996 2.20581 5.72009 2.20581 6.07735V13.9226C2.20581 14.2799 2.39641 14.61 2.70581 14.7887L9.50004 18.7113C9.80944 18.89 10.1906 18.89 10.5 18.7113L17.2943 14.7887C17.6037 14.61 17.7943 14.2799 17.7943 13.9227V8.75248",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.5L10 10M10 10V18.5M10 10L11.6821 9.03879",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 9,
    height: 9,
    rx: 4.5,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5L13.6667 7L17 4",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.33ac660d5b9de5f2957e54463ba714fd.svg";
export { ForwardRef as ReactComponent };